import { createReducer, on } from '@ngrx/store'
import * as Actions from '@store/actions/program.actions'

export default createReducer(
    undefined,
    on(Actions.getProgramSuccess, (_, { payload }) => payload)
)
